import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Vishrantwaditomumbai() {



const cardData = {
  keyword: " Vishrantwadi to Mumbai Cabs ",

headingDescription: "Velocity Cab provides reliable and comfortable Vishrantwadi to Mumbai cab services, ensuring a smooth and hassle-free journey for business trips, airport transfers, family outings, and leisure travel. Our professional drivers, well-maintained vehicles, and punctual pickups make traveling from Vishrantwadi to Mumbai convenient and stress-free. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Vishrantwadi to Mumbai cab travel.",

topPlaces: [
  {
    title: "Elephanta Caves",
    description: "Elephanta Caves is a UNESCO World Heritage Site located on Elephanta Island and is one of Mumbai's most remarkable historical attractions. Travelers booking an Innova Crysta on rent in Pune can enjoy a comfortable drive to the Gateway of India before taking a ferry to explore the ancient rock-cut caves. The impressive sculptures, especially the massive Trimurti of Lord Shiva, make it a must-visit destination for history lovers and photographers."
  },
  {
    title: "Powai Lake",
    description: "Powai Lake is a peaceful destination surrounded by lush greenery, luxury hotels, cafés, and scenic walking paths. Visitors choosing an Innova Crysta on rent in Pune can comfortably reach this beautiful location to enjoy boating, lakeside dining, and relaxing evening strolls. It is an ideal spot for families, couples, and anyone looking to unwind in the heart of Mumbai."
  },
  {
    title: "Chhatrapati Shivaji Maharaj Terminus",
    description: "Chhatrapati Shivaji Maharaj Terminus is a UNESCO World Heritage Site renowned for its stunning Victorian Gothic architecture. Travelers renting an Innova Crysta in Pune can conveniently visit this iconic railway station while exploring nearby heritage buildings, local markets, and historic streets that showcase Mumbai's rich colonial legacy."
  },
  {
    title: "Bandra Fort",
    description: "Bandra Fort, also known as Castella de Aguada, is a historic Portuguese fort overlooking the Arabian Sea. Travelers hiring an Innova Crysta on rent in Pune can enjoy breathtaking views of the Bandra-Worli Sea Link, explore the ancient fort walls, and capture memorable photographs from one of Mumbai's most scenic viewpoints."
  },
  {
    title: "Juhu Beach",
    description: "Juhu Beach is one of Mumbai's most famous beaches, attracting visitors with its lively atmosphere, delicious street food, and spectacular sunsets. Booking an Innova Crysta on rent in Pune makes the road journey comfortable for families and groups planning a fun-filled beach outing and a relaxing evening by the Arabian Sea."
  },
  {
    title: "Global Vipassana Pagoda",
    description: "Global Vipassana Pagoda is an architectural masterpiece and an internationally renowned meditation center near Gorai. Visitors choosing an Innova Crysta on rent in Pune can comfortably explore its magnificent golden dome, peaceful meditation halls, and informative museum while enjoying a calm and spiritual experience."
  },
  {
    title: "Hanging Gardens",
    description: "Hanging Gardens on Malabar Hill offer beautifully landscaped gardens, artistic hedges, and panoramic views of Marine Drive. Travelers renting an Innova Crysta in Pune can spend a peaceful afternoon surrounded by greenery while enjoying one of Mumbai's most popular viewpoints overlooking the Arabian Sea."
  },
  {
    title: "Colaba Causeway",
    description: "Colaba Causeway is one of Mumbai's busiest shopping streets, offering trendy fashion, antiques, handicrafts, cafés, and local restaurants. Travelers booking an Innova Crysta on rent in Pune can comfortably explore this lively market and enjoy a memorable shopping experience in the heart of South Mumbai."
  },
  {
    title: "Siddhivinayak Temple",
    description: "Siddhivinayak Temple is one of Mumbai's most sacred temples dedicated to Lord Ganesha. Visitors hiring an Innova Crysta on rent in Pune can conveniently visit this famous spiritual destination to seek blessings while experiencing the temple's peaceful atmosphere and remarkable architecture."
  },
  {
    title: "Worli Sea Face",
    description: "Worli Sea Face is a scenic coastal promenade known for its cool sea breeze, beautiful skyline, and stunning sunset views. Travelers choosing an Innova Crysta on rent in Pune can relax by the waterfront, enjoy leisurely walks, and admire spectacular views of the Arabian Sea and the Bandra-Worli Sea Link."
  }
],



services: [
{
name: "Vishrantwadi to Mumbai Cab Price",
description: "Vishrantwadi to Mumbai cab price service provides transparent fare details for passengers traveling between Vishrantwadi in Pune and Mumbai city. Comfortable vehicles such as sedan, Ertiga, and Innova ensure smooth expressway travel. Professional drivers provide punctual pickup from homes, offices, and residential areas across Vishrantwadi."
},
{
name: "Dhanori to Mumbai Cab Service",
description: "Dhanori to Mumbai cab service offers reliable transportation between Pune’s Dhanori area and Mumbai city. Comfortable vehicles and experienced drivers ensure safe journeys via the Mumbai–Pune Expressway for business travel, airport transfers, and family trips."
},
{
name: "Vishrantwadi to Mumbai Airport Cab",
description: "Vishrantwadi to Mumbai Airport cab service provides dependable airport transfers from Pune to Chhatrapati Shivaji Maharaj International Airport. Vehicles offer comfortable seating and luggage space suitable for airport travel."
},
{
name: "Vishrantwadi to Dadar Cab",
description: "Vishrantwadi to Dadar cab service offers convenient transportation between Pune’s Vishrantwadi area and Dadar in Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Mumbai to Vishrantwadi Cab",
description: "Mumbai to Vishrantwadi cab service provides dependable transportation for passengers traveling from Mumbai to Pune. Comfortable vehicles and experienced drivers ensure smooth highway travel."
},
{
name: "Bhosari to Mumbai Cabs",
description: "Bhosari to Mumbai cab service offers reliable intercity transportation between Pune’s Bhosari area and Mumbai city. Vehicles are comfortable and suitable for long-distance expressway travel."
},
{
name: "Bhosari to Mumbai Cab Service",
description: "Bhosari to Mumbai cab service provides dependable transportation between Bhosari in Pune and Mumbai city. Professional drivers and well-maintained vehicles ensure safe highway journeys."
},
{
name: "Cab Service in Dhanori",
description: "Cab service in Dhanori provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel experiences across Pune."
},
{
name: "Cab Service in Vishrantwadi",
description: "Cab service in Vishrantwadi offers convenient transportation for city rides, airport transfers, and intercity travel. Vehicles are comfortable and suitable for daily commuting and long-distance journeys."
},
{
name: "Taxi Service in Vishrantwadi",
description: "Taxi service in Vishrantwadi provides dependable transportation for passengers traveling within Pune or planning outstation trips. Comfortable vehicles and experienced drivers ensure safe journeys."
},
{
name: "Innova Crysta on Rent in Vishrantwadi",
description: "Innova Crysta on rent in Vishrantwadi offers premium SUV rental for passengers seeking spacious and comfortable transportation. Ideal for family trips, airport transfers, and corporate travel."
},
{
name: "Innova Crysta Hire in Bhosari",
description: "Innova Crysta hire in Bhosari provides luxury SUV transportation for travelers planning outstation trips and airport transfers. Spacious seating and smooth highway travel ensure comfortable journeys."
},
{
name: "Ertiga on Rent in Vishrantwadi",
description: "Ertiga on rent in Vishrantwadi provides comfortable 7-seater SUV transportation suitable for families and small groups. The vehicle offers spacious seating and smooth highway travel."
},
{
name: "Sedan Car on Rent in Bhosari",
description: "Sedan car on rent in Bhosari offers economical transportation using comfortable vehicles like Swift Dzire and Etios. Ideal for city rides, airport transfers, and outstation trips."
},
{
name: "Cab Service in Pune",
description: "Cab service in Pune provides reliable transportation for local rides, airport transfers, and outstation journeys. Comfortable vehicles and professional drivers ensure safe travel across Pune."
},
{
name: "Pune to Mumbai Airport Cab",
description: "Pune to Mumbai Airport cab service provides dependable airport transportation for passengers traveling from Pune city to Mumbai Airport terminals. Vehicles ensure comfortable seating and safe expressway travel."
},
{
name: "Pune Mumbai Cab",
description: "Pune Mumbai cab service offers dependable intercity transportation between Pune and Mumbai. Comfortable vehicles and experienced drivers ensure safe highway journeys."
},
{
name: "Tingre Nagar to Mumbai Cabs",
description: "Tingre Nagar to Mumbai cab service offers reliable transportation between Pune’s Tingre Nagar area and Mumbai city. Comfortable vehicles ensure smooth expressway travel."
},
{
name: "Charholi to Mumbai Cab Service",
description: "Charholi to Mumbai cab service provides dependable transportation between Pune’s Charholi area and Mumbai city. Vehicles are comfortable and suitable for long-distance highway travel."
},
{
name: "Cab Service in Vishrantwadi Pune",
description: "Cab service in Vishrantwadi Pune provides reliable transportation for local travel, airport transfers, and outstation trips. Comfortable vehicles and professional drivers ensure safe journeys."
},
{
name: "Vishrantwadi to Mumbai Cab",
description: "Vishrantwadi to Mumbai cab service offers dependable transportation between Pune and Mumbai. Comfortable vehicles and professional drivers ensure safe expressway travel."
},
{
name: "Vishrantwadi to Mumbai Taxi",
description: "Vishrantwadi to Mumbai taxi service provides reliable intercity transportation between Pune and Mumbai city with comfortable vehicles."
},
{
name: "Vishrantwadi to Mumbai Cab Service",
description: "Vishrantwadi to Mumbai cab service offers convenient transportation between Pune and Mumbai. Experienced drivers ensure safe highway travel with comfortable vehicles."
},
{
name: "Vishrantwadi to Mumbai Taxi Service",
description: "Vishrantwadi to Mumbai taxi service provides dependable travel options for passengers heading from Pune to Mumbai city."
},
{
name: "Vishrantwadi to Mumbai Cab Booking",
description: "Vishrantwadi to Mumbai cab booking service allows passengers to easily reserve taxis for intercity travel. Flexible booking options ensure convenient travel planning."
},
{
name: "Cab from Vishrantwadi to Mumbai",
description: "Cab from Vishrantwadi to Mumbai service offers reliable transportation between Pune and Mumbai with comfortable vehicles and experienced drivers."
}
],

tableData: [
["Vishrantwadi to Mumbai Cab Price","Dhanori to Mumbai Cab Service"],
["Vishrantwadi to Mumbai Airport Cab","Vishrantwadi to Dadar Cab"],
["Mumbai to Vishrantwadi Cab","Bhosari to Mumbai Cabs"],
["Bhosari to Mumbai Cab Service","Cab Service in Dhanori"],
["Cab Service in Vishrantwadi","Taxi Service in Vishrantwadi"],
["Innova Crysta on Rent in Vishrantwadi","Innova Crysta Hire in Bhosari"],
["Ertiga on Rent in Vishrantwadi","Sedan Car on Rent in Bhosari"],
["Cab Service in Pune","Pune to Mumbai Airport Cab"],
["Pune Mumbai Cab","Tingre Nagar to Mumbai Cabs"],
["Charholi to Mumbai Cab Service","Cab Service in Vishrantwadi Pune"],
["Vishrantwadi to Mumbai Cab","Vishrantwadi to Mumbai Taxi"],
["Vishrantwadi to Mumbai Cab Service","Vishrantwadi to Mumbai Taxi Service"],
["Vishrantwadi to Mumbai Cab Booking","Cab from Vishrantwadi to Mumbai"]
],





whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Velocity Cabs provides experienced drivers who regularly travel from Vishrantwadi to Mumbai via the Mumbai Pune Expressway. Their knowledge of highway routes and traffic patterns ensures safe and timely intercity travel."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs offers transparent and affordable pricing for Vishrantwadi to Mumbai cab bookings. Customers receive clear fare details including toll charges and driver allowance before confirming the ride."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Vishrantwadi to Mumbai cab service operates 24 hours a day. Whether you need an early morning airport transfer, corporate travel, or late night ride, Velocity Cabs ensures reliable transportation anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles in the Velocity Cabs fleet are fully air-conditioned, well maintained, and regularly cleaned to provide passengers with a comfortable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, airport transfers, and customized travel plans from Vishrantwadi to Mumbai."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Velocity Cabs offers a wide range of vehicles including sedan cars, SUVs like Ertiga and Innova, premium vehicles like Innova Crysta, and Tempo Travellers suitable for individuals, families, and corporate travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup in Vishrantwadi",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and residential societies across Vishrantwadi and nearby areas like Dhanori, Tingre Nagar, Lohegaon, and Yerwada."
  },
  {
    WhyChooseheading: "Trusted Intercity Cab Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Vishrantwadi to Mumbai cab bookings thanks to punctual drivers, comfortable vehicles, and professional intercity travel service."
  }
]
};

const faqData = [
  { question: "Do you provide Vishrantwadi to Mumbai cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Vishrantwadi to Mumbai with professional drivers and comfortable vehicles." },
  { question: "How far is Vishrantwadi from Mumbai?", answer: "The road distance from Vishrantwadi to Mumbai is around 146–150 km and the journey usually takes about 3 to 4 hours depending on traffic." },
  { question: "Is Vishrantwadi to Mumbai cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 to match customer travel schedules." },
  { question: "Which vehicles are available for Vishrantwadi to Mumbai travel?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Vishrantwadi to Mumbai?", answer: "Yes, we provide both one-way and round-trip cab services between Vishrantwadi and Mumbai." },
  { question: "Do you provide pickup from homes and hotels?", answer: "Yes, our drivers provide doorstep pickup from homes, hotels, offices, and residential societies across Vishrantwadi." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Velocity Cabs are fully air-conditioned for comfortable long-distance travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Vishrantwadi to Mumbai cab services online or through phone booking." },
  { question: "Do you provide airport drop service in Mumbai?", answer: "Yes, Velocity Cabs provides drop services to Mumbai Airport and other major locations across Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Shinde",
    feedback:
      "Vishrantwadi to Mumbai cab service with Velocity Cab was very comfortable and smooth. The vehicle was clean, and the long journey was handled with great professionalism.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aishwarya Deshmukh",
    feedback:
      "The Vishrantwadi to Mumbai cab experience with Velocity Cab was excellent. The ride was punctual, safe, and completely hassle-free from start to end.",
    rating: 5
  }
];





































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Vishrantwadi to Mumbai Cab Service | Velocity Cabs",
  "description": "Velocity Cabs provides reliable Vishrantwadi to Mumbai cab service with affordable fares and professional drivers. Book one way and round trip taxis including Innova, Ertiga, and Sedan cabs for airport transfers, Dadar, Dhanori, Bhosari, Tingre Nagar, Charholi, and other destinations. Enjoy safe, comfortable, and punctual rides with easy online booking from Vishrantwadi to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Velocity Cabs"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.velocitycabs.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Vishrantwadi to Mumbai Cab | Call +91 9136271336 | Velocity Cabs</title>
  <meta 
    name="description" 
    content="Book Vishrantwadi to Mumbai cab with Velocity Cabs. Affordable one way, round trip & airport drop taxis including Innova, Ertiga & Sedan for Dadar, Dhanori, Bhosari, Tingre Nagar & Charholi." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/28.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Vishrantwaditomumbai;